import { useNeedPay } from 'modules/admin';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import { useProductSet } from './context/ProductSetProvider';
import CatalogCategoryFilter from '../CatalogCategory/CatalogCategoryFilter';
import CatalogAdminDropdown from '../CatalogCategory/CatalogAdminDropdown';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import SolarIcon from 'components/icons/SolarIcon';

interface SetToolBarProps {
    setEditSetId: (setId: number) => void;
    filterCategoryIds: number[];
    setFilterCategoryIds: (ids: number[]) => void;
}

const SetToolBar = ({ setEditSetId, filterCategoryIds, setFilterCategoryIds }: SetToolBarProps) => {
    const { t } = useTranslation(['Sets', 'common']);
    const { needPay } = useNeedPay();
    const { auth } = useAuth();
    const { triggerListReset, triggerListRefresh, showUpdated, toggleListColumn } = useProductSet();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                {hasUserAccess(auth?.user, 'prodEdit') && (
                    <Button className="fs-14" size="sm" variant="success" onClick={() => { if (!needPay()) setEditSetId(0); }}>
                        <SolarIcon name="plus" className="fs-14 p-0" />
                        <span className="ms-1">{t('toolAddSet')}</span>
                    </Button>
                )}

                {!!auth?.user?.admin && <CatalogAdminDropdown kind="set" />}

                <ListToolBarActions
                    filters={
                        <CatalogCategoryFilter
                            kind="set"
                            filterCategoryIds={filterCategoryIds}
                            setFilterCategoryIds={setFilterCategoryIds}
                        />
                    }
                    onReset={triggerListReset}
                    onRefresh={triggerListRefresh}
                    columns={{
                        items: [
                            { id: 'updated', label: t('fields.updated'), visible: showUpdated },
                        ],
                        onToggle: (id) => toggleListColumn(id as 'updated'),
                    }}
                />
            </div>
        </div>
    );
};

export default SetToolBar;
